import HeaderLayout from "./HeaderLayout";
import LeftSideLayout from "./LeftSideLayout";
import ContentLayout from "./ContentLayout";
import react from "react";
import { useParams, useLocation } from "react-router-dom";
import { getEmbedded } from "../../util/utils";

const Layout = (props) => {
  let params = useParams();
  let query = useLocation();

  const isEmbedded = getEmbedded();
  let styleMain = {};
  let styleApp = {};
  if (isEmbedded) {
    styleMain = { gridRow: "1 /span 2" };
    styleApp = { paddingTop: "0" };
  }

  return (
    <div className="app" style={styleApp}>
      <HeaderLayout render>
        {react.cloneElement(props.header, { params: params, query: query })}
      </HeaderLayout>
      <div
        className={`main ${isEmbedded ? "mainHidden" : ""}`}
        style={styleMain}
      >
        <LeftSideLayout>
          {react.cloneElement(props.leftSide, { params: params })}
        </LeftSideLayout>
        <ContentLayout>
          {react.cloneElement(props.content, { params: params })}
        </ContentLayout>
      </div>
    </div>
  );
};

export default Layout;
